module.exports = __webpack_public_path__ + "static/media/javascript-fullstack.0e5ebf74.jpg";